export const shareProduct = async (productLabel) => {
  const url = window.location.href;
  const title = productLabel || document.title;

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return { method: 'share', success: true };
    } catch (err) {
      if (err.name !== 'AbortError') {
        // Fallback to clipboard if share fails
        await navigator.clipboard.writeText(url);
        return { method: 'clipboard', success: true };
      }
      return { method: 'share', success: false };
    }
  }

  // Fallback: copy to clipboard
  try {
    await navigator.clipboard.writeText(url);
    return { method: 'clipboard', success: true };
  } catch {
    // Last resort: use execCommand
    const textarea = document.createElement('textarea');
    textarea.value = url;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    return { method: 'clipboard', success: true };
  }
};
